const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },
  containerPaper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    padding: "20px",
  },
  boxSubTitle: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    mb: 1,
  },
  paperSearchCliente: {
    p: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
    borderRadius: "16px",
    width: "100%",
  },
  paperSearchCardCliente: {
    p: 1,
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "space-between",
    gap: 0.4,
    width: "100%",
    alignItems: "center",
  },
  titleCard: {
    fontWeight: "bold",
    fontSize: "16px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "800px",
  },
  containerDataSearch: {
    display: "flex",
    flexDirection: "column",
    p: 1,
    width: "100%",
    flex: 1,
    minWidth: 0,
  },
  containerButtonSearch: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 45px",
  },
  boxDataCard: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    justifyContent: "space-between",
    width: "100%",
  },
  subDataCard: {
    fontWeight: "bold",
    fontSize: "14px",
    opacity: 0.6,
  },
  opcaoCliente: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 1,
  },
});

export default styles;
